import reducer, { actions, selectors, STATE_KEY } from './modules/slice';

export { reducer, actions, selectors };
export const loggedInUserStateKey = STATE_KEY;
